import { AsyncOrNot, ChatAdapter, ChatMessageData, ChatReaction, ChatReactionType, ChatRef } from "@kalyzee/kast-web-sdk/web-components";

/**
 * Very simple slave chat adapter, it's only purpose is to store the messages
 * and give them to the possibly multiple chat components using it at once
 * 
 * It does not implement any message sending/editing functions
 */
export class SlaveChatAdapter implements ChatAdapter {
  private refs: ChatRef[] = [];

  private enabled: boolean;
  private messages: ChatMessageData[];

  constructor(enabled: boolean, messages: ChatMessageData[]) {
    this.enabled = enabled;
    this.messages = messages;
  }

  enable() {
    this.enabled = true;
    this.refs.forEach(ref => ref.enable());
  }

  disable() {
    this.enabled = false;
    this.refs.forEach(ref => ref.disable());
  }

  updateMessages(messages: ChatMessageData[]) {
    this.messages = messages;
    this.refs.forEach(ref => ref.setMessages(messages));
  }

  getId(): string {
    return "slave-chat-adapter";
  }

  getDefaultMessages(): ChatMessageData[] {
    return this.messages;
  }
  
  subscribeMessageReader(): { flush: () => void; } {
    return {
      flush: () => { /* No-op */ }
    }
  }

  onLoadMessages?: ((options: { skip: number; beforeDate?: Date; }) => AsyncOrNot<boolean>) | undefined;

  onSendMessage?: ((text: string) => AsyncOrNot<boolean>) | undefined;

  onAddReaction?: ((message: ChatMessageData, reaction: ChatReactionType) => AsyncOrNot<boolean>) | undefined;

  onRemoveReaction?: ((message: ChatMessageData, reaction: ChatReaction) => AsyncOrNot<boolean>) | undefined;

  onDeleteMessage?: ((message: ChatMessageData) => AsyncOrNot<boolean>) | undefined;

  onUnreadMessages?: ((messages: ChatMessageData[]) => AsyncOrNot<boolean>) | undefined;
  
  onRef(ref: ChatRef | undefined) {
    if (ref) {
      ref.setMessages(this.messages);
      this.enabled ? ref.enable() : ref.disable();
      this.refs.push(ref);
    }
  }

  offRef(ref: ChatRef | undefined) {
    if (ref) {
      this.refs = this.refs.filter(r => r !== ref);
    }
  }
}